//================================//
//    SHUFFLED INK | PAGE LOADER    //
//================================//

setTimeout( function() {
	jQuery( '#page-loader' ).addClass('loaded');
	jQuery( '#page-loader' ).fadeOut( "slow" );
}, 1000 );